import { Cache } from './Cache';

export default Cache;
